exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-wrap[data-v-0e053718]{width:100%;height:200px;margin:8px 0 4px;padding:10px;box-sizing:border-box;border:1px solid #c0ccda;border-radius:4px;overflow:auto;gap:10px}.card-footer[data-v-0e053718]{text-align:right;font-size:14px;line-height:1.5}.card-item[data-v-0e053718]{display:inline-block;margin:4px;padding:0 4px;border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}.date-picker[data-v-0e053718]{width:48%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0e053718&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/Activity/ThemeRunning/ThemeDetail.vue
// module id = 438
// module chunks = 0